import React from 'react';
import {IValidationErrorObject} from '../../../../incase-domain/common/validationErrorResponse';
import {IElementLikertScale} from '../../../../incase-domain/elements/question/likertScale';
import ElementShadow from '../common/elementShadow';
import QuestionText from './components/QustionText';
import QuestionOptions, {QUESTION_OPTIONS} from './components/QuestionOptions';
import AdvancedOptions from './components/advancedOptions/AdvancedOptions';
import LikertScaleQuestions from './likertScale/LikertScaleQuestions';
import LikertScaleScale from './likertScale/LikertScaleScale';
import {TABS} from '../../form/part/tabs';
import {useHighlightedElement, useSetHighlightedElement} from '../../../../utils/hooks/slideUpdates/useSetSlideElement';
import AnimationForm from '../common/animationForm';

interface IHighlightedLikertScaleElementComponentProps {
    errors: IValidationErrorObject | null;
    activeTab: string;
}

function HighlightedLikertScaleQuestionComponent(props: IHighlightedLikertScaleElementComponentProps): JSX.Element {
    const {errors, activeTab} = props;
    const updateHighlightedElement = useSetHighlightedElement();
    const highlightedElement = useHighlightedElement() as IElementLikertScale;

    if (activeTab === TABS.STYLE.id) {
        return (
            <>
                <AdvancedOptions
                    highlightedElement={highlightedElement}
                    highlightedElementChangeHandler={updateHighlightedElement}
                    answerColorFields={[]}
                />
                <ElementShadow highlightedElement={highlightedElement} highlightedElementChangeHandler={updateHighlightedElement} />
            </>
        );
    }

    if (activeTab === TABS.ADVANCED.id) {
        return (
            <>
                <QuestionOptions
                    highlightedElement={highlightedElement}
                    highlightedElementChangeHandler={updateHighlightedElement}
                    questionOptions={[QUESTION_OPTIONS.BLOCKING_QUESTION, QUESTION_OPTIONS.SHOW_IN_REPORT, QUESTION_OPTIONS.SLIDER_VIEW]}
                />
                <AnimationForm
                    appearAfter={highlightedElement.appearAfter || 0}
                    elementAnimations={highlightedElement.elementAnimations}
                    highlightedElementChangeHandler={updateHighlightedElement}
                />
            </>
        );
    }

    return (
        <>
            <QuestionText
                highlightedElement={highlightedElement}
                errors={errors}
                highlightedElementChangeHandler={updateHighlightedElement}
            />
            <LikertScaleQuestions
                highlightedElement={highlightedElement}
                errors={errors}
                highlightedElementChangeHandler={updateHighlightedElement}
            />
            <LikertScaleScale
                highlightedElement={highlightedElement}
                errors={errors}
                highlightedElementChangeHandler={updateHighlightedElement}
            />
        </>
    );
}

export default HighlightedLikertScaleQuestionComponent;
